var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.title,"size":_vm.modalSize,"hide-footer":_vm.hideFooter,"ok-only":_vm.okOnly,"ok-title":_vm.okLabel,"cancel-title":_vm.cancelLabel,"centered":Boolean(_vm.displayCenter),"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.onProcess}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/modal/modal.vue